<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        color="red"
        max-width="290px"
        min-width="auto"
        :disabled="disabled"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-form ref="form">
                <v-text-field
                    class="shrink mt-md-6"
                    readonly
                    outlined
                    :label="labelText"
                    dense
                    :rules="[periodDateRule]"
                    required
                    v-bind="attrs"
                    v-on="on"
                    color="secondary lighten-1"
                    :disabled="disabled"
                >
                    <template v-slot:prepend-inner>
                        <v-icon class="mt-1 mr-1" size="18">mdi-calendar</v-icon>
                    </template>
                </v-text-field>
            </v-form>
        </template>
        <v-date-picker
            v-if="periodDate"
            v-model="periodDate"
            no-title
            locale="pt-br"
            range
            :type="type === 'daily' ? 'date' : 'month'"
            :min="type === 'daily' ? '2020-01-01' : '2020-01'"
            :max="maxPeriodDate()"
            color="secondary lighten-1"
        >
            <v-spacer></v-spacer>
            <v-btn
                class="button-text"
                text
                color="secondary lighten-1"
                @click="cancelDateSelected"
            >
                Cancelar
            </v-btn>
            <v-btn
                class="button-text"
                text
                color="secondary lighten-1"
                @click="applyDateSelected"
                :disabled="periodDateRule !== true"
            >
                Aplicar
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
import moment from 'moment';
export default {
    name: 'DateField',
    props:{
        type:{
            type: String,
            default: 'daily',
            validator: (value)=>{
                return ['daily', 'monthly'].indexOf(value) !== -1;
            }
        },
        disabled:{
            type: Boolean,
            default: false
        }
    },
    data:()=>({
        menu: false,
        periodDate: undefined,
        dateStart: moment().locale('pt-br').subtract(7, 'days').format('YYYY-MM-DD'),
        currentDaily: moment().locale('pt-br').format('YYYY-MM-DD'),
        beforeDateReange: undefined
    }),
    computed:{
        labelText(){
            const stringFormat = this.type === 'daily' ? 'DD/MM/YYYY' : 'MM/YYYY';
            if(this.periodDate){
                return `De ${moment(this.periodDate[0]).format(stringFormat)} a ${moment(this.periodDate[1]).format(stringFormat)}`;
            }
            return '';
        },
        periodDateRule(){
            if(this.periodDate){
                if(!this.periodDate.length || this.periodDate.length === 1) return 'Selecione um período.'
                const orderDate = this.orderPeriodDate(this.periodDate);
                const unitOfTime = this.type === 'daily' ? 'days' : 'months';
                const max = this.type === 'daily' ? (365*2) : (12*2);
                if (this.type === 'daily' && orderDate.length > 1 && moment(orderDate[1]).diff(moment(orderDate[0]), unitOfTime) > max) {
                    return 'O período máximo deve ser 2 anos.';
                }
            }
            return true;
        }
    },
    methods:{
        cancelDateSelected(){
            this.menu = false;
            this.$emit('cancelDateSelected');
        },
        applyDateSelected(){
            this.menu = false;

            if(this.$refs.form.validate()){
                this.periodDate = this.orderPeriodDate(this.periodDate);

                this.$emit('applyDateSelected', this.periodDate);
            }
        },
        backOldDateValue(date){
            this.periodDate = date;
        },
        maxPeriodDate(){
            const stringFormat = this.type === 'daily' ? 'YYYY-MM-DD' : 'YYYY-MM';
            /* if(this.periodDate){
                const date = moment(this.periodDate[0]);
                const max = date.clone().add(1, 'year');
                if(moment().isBefore(max)) {
                    return moment().format(stringFormat)
                }
                else {
                    return max.format(stringFormat)
                }
            }else{
                return moment().format(stringFormat);
            } */
            return moment().format(stringFormat);
        },
        minPeriodDate(){
            const stringFormat = this.type === 'daily' ? 'YYYY-MM-DD' : 'YYYY-MM';
            if(this.periodDate){
                let ordereddate = this.orderPeriodDate(this.periodDate);
                const date = ordereddate.length > 1 ? moment(ordereddate[1]) : moment(ordereddate[0]);
                const min = date.clone().subtract(2, 'years');
                return min.format(stringFormat)
            }else{
                return moment().subtract(2, 'years').format(stringFormat);
            }
        },
        orderPeriodDate(date){
            const stringFormat = this.type === 'daily' ? 'YYYY-MM-DD' : 'YYYY-MM';
            let initDate;
            let finalDate;

            if(date.length > 1){
                if(moment(date[0]).isBefore(moment(date[1]))){
                    initDate =  moment(date[0]).format(stringFormat);
                    finalDate = moment(date[1]).format(stringFormat);
                }else{
                    initDate = moment(date[1]).format(stringFormat);
                    finalDate = moment(date[0]).format(stringFormat);
                }

                return [initDate, finalDate];
            }

            return date;
        }
    }
}
</script>
